import React, {useState} from 'react'
import {Button, Col, Row} from 'react-bootstrap';

import Notify from '../../services/Notify';
import {ModalMessage} from '../../component/Modal/ModalMessage';
import {dayMonthYearAtTimeWithSeconds} from '../../utils/dates';
import {ALERT_TITLE} from "./Select/AlertSelect";
import {InputWithLabel} from '../../component/Form/InputWithLabel';
import {AlertConfigurationsService} from '../../services/AlertConfigurationsService';

class ConfigurationAlertTriggerGridTemplate {

  title = "Configuração do disparo de alertas";

  exportNewPage = true;
  showPdfButton = false;
  customFilters = {friendlyName: null}

  actionsButtons = (row, reloadGrid) => {
    const [show, setShow] = useState(false)

    const deleteItem = async () => {
      try {
        await new AlertConfigurationsService().deleteById(row.original.id)
        Notify.success('Alerta deletado com sucesso!')
      } catch (error) {
        Notify.error('Erro ao excluir alerta', error)
      } finally {
        setShow(false)
        reloadGrid && reloadGrid()
      }
    }

    return (
      <Row className="d-flex align-items-center justify-content-around flex-row">
        <Col md={6}>
          <Button block bsStyle="secondary" href={`#/alerts-triggers/edit/${row.original.id}`}>Editar</Button>
        </Col>
        <Col md={6}>
          <Button block bsStyle="danger" onClick={() => setShow(true)}>Excluir</Button>
        </Col>
        <ModalMessage
          showModal={show}
          handleShowModal={setShow}
          title="Deseja deletar o alerta?"
          successButtonAction={deleteItem}/>
      </Row>
    )
  }

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={4}>
          <InputWithLabel label="Nome" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e.trim()
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true
    },
    {
      Header: "Tipo",
      accessor: "type",
      Cell: row => row.original.type && ALERT_TITLE[row.original.type] || 'Não existe alertas para este tipo'
    },
    {
      Header: "Data de criação",
      accessor: "createdAt",
      Cell: row => row.original.createdAt && dayMonthYearAtTimeWithSeconds(row.original.createdAt)
    },
    {
      Header: "Status",
      accessor: "active",
      Cell: row => row.original.active && row.original.active ? 'Ativo' : 'Desativado'
    },
    {
      Header: "Ações",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => this.actionsButtons(row, this.forceReload)
    }
  ];

  endpoint = () => {
    const params = new URLSearchParams({})
    const {friendlyName} = this.customFilters

    friendlyName && params.append('friendlyName', friendlyName)

    return `alerts/v1/alerts-configurations?${params.toString()}`
  }
}

export {ConfigurationAlertTriggerGridTemplate}



// WEBPACK FOOTER //
// ./src/pages/Alerts/AlertsTriggerGridPage.js